import { Component, Prop, Vue } from 'vue-property-decorator';
import { VNode, CreateElement, VueConstructor, VNodeData } from 'vue';

type Variant = 'fullWidth' | 'inset' | 'middle';

@Component
export default class ClDivider extends Vue {
  /**
   * Absolutely position the element.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public absolute!: boolean;

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  @Prop({
    type: [String, Function],
    default: 'hr'
  })
  public component!: string | VueConstructor<Vue>;

  /**
   * If `true`, the divider will have a lighter color.
   */
  @Prop({
    type: Boolean,
    default: false
  })
  public light!: boolean;

  /**
   *  The variant to use.
   */
  @Prop({
    type: String as () => Variant,
    validator: x => ['fullWidth', 'inset', 'middle'].includes(x),
    default: 'fullWidth'
  })
  public variant!: Variant;

  render(h: CreateElement): VNode {
    const data: VNodeData = {
      class: {
        'cl-divider': true,
        [`cl-divider--variant-${this.variant}`]: true,
        'cl-divider--absolute': this.absolute,
        'cl-divider--light': this.light
      }
    };
    return h(this.component, data);
  }
}
